import { AssigneeType } from '@enums/assignee-type.enum';
export function isTechnician(assignee) {
    var _a;
    return (assignee.type === AssigneeType.TECHNICIAN || ((_a = assignee.key) === null || _a === void 0 ? void 0 : _a.startsWith('technician-'))) && !!assignee.info;
}
export function isSubcontractor(assignee) {
    var _a;
    return ((assignee.type === AssigneeType.SUBCONTRACTOR || ((_a = assignee.key) === null || _a === void 0 ? void 0 : _a.startsWith('subcontractor-'))) && !!assignee.info);
}
